import { render } from "./TransactionSubCard.vue?vue&type=template&id=7775a6b3&scoped=true&ts=true"
import script from "./TransactionSubCard.vue?vue&type=script&lang=ts"
export * from "./TransactionSubCard.vue?vue&type=script&lang=ts"

import "./TransactionSubCard.vue?vue&type=style&index=0&id=7775a6b3&lang=scss&scoped=true"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7775a6b3"]])

export default __exports__